import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from 'components/Icon';
import ImageIcon from 'components/ImageIcon';
import OnPageEditing from 'components/OnPageEditing';

import css from './FeatureListBlock.module.scss';

import { THEMES, getThemeClassNames } from 'constants/themes';

const Content = ({
    icon,
    iconNew,
    title,
    subtitle,
    description,
    link,
    onPageEditing,
}) => (
    <div className={css.item}>
        {iconNew ? (
            <ImageIcon {...iconNew} />
        ) : 
            (icon ? (
                <Icon icon={icon} />
            ) : null)
        }
        <OnPageEditing active={onPageEditing} property="Title">
            {!icon && (
                <p className={css.title}>{title}</p>
            )}
        </OnPageEditing>
        <OnPageEditing active={onPageEditing} property="Subtitle">
            {subtitle && <h3 className={css.heading}>{link ? <a href={link}>{subtitle}</a> : subtitle}</h3>}
        </OnPageEditing>
        <OnPageEditing active={onPageEditing} property="Description">
            <div
                className={cn(css.wysiwyg, "wysiwyg")}
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </OnPageEditing>
    </div>
);

Content.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    iconNew: PropTypes.shape(ImageIcon.propTypes),
    icon: PropTypes.string,
    link: PropTypes.string,
    contentType: PropTypes.string,
    blockId: PropTypes.number,
    onPageEditing: PropTypes.bool,
};

const FeatureListBlock = ({
    blockId,
    heading,
    text,
    features,
    contentType,
    theme
}) => (
    <div className={cn(css.block, getThemeClassNames(css, theme))} data-block={blockId}>
        <div className={css.wrapper}>
            {(heading || text) && (
                <header>
                    <OnPageEditing active={contentType === 'FeatureListBlock'} property="Heading">
                        {heading && <h2>{heading}</h2>}
                    </OnPageEditing>
                    <OnPageEditing active={contentType === 'FeatureListBlock'} property="Text">
                        {text && <p>{text}</p>}
                    </OnPageEditing>
                </header>
            )}
            <OnPageEditing active={contentType === 'FeatureListBlock'} property="Features">
                <ul className={css.content}>
                    {features && features.map(a => (
                        <li key={a.blockId}>
                            <Content
                                onPageEditing={contentType !== 'FeatureListBlock'}
                                {...a}
                            />
                        </li>
                    ))}
                </ul>
            </OnPageEditing>
        </div>
    </div>
);

FeatureListBlock.propTypes = {
    blockId: PropTypes.number,
    contentType: PropTypes.string,
    heading: PropTypes.string,
    text: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        icon: PropTypes.string,
        link: PropTypes.string,
        contentType: PropTypes.string,
        blockId: PropTypes.number
    })).isRequired,
    theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
};

FeatureListBlock.defaultProps = {
    theme: THEMES.zebra
};

export default FeatureListBlock;



// WEBPACK FOOTER //
// ./src/components/FeatureListBlock/FeatureListBlock.jsx